import SelectSingle from './select-single'
import SelectMultiple from './select-multiple'

interface Theme {
  SelectSingle: any
  SelectMultiple: any
}

export default {
  SelectSingle,
  SelectMultiple
} as Theme
